import React, { useState } from "react";

const SearchBar = ({ onSubmit }) => {
  const [term, setTerm] = useState("");

  const onInputChange = (e) => {
    setTerm(e.target.value);
  };

  const onFormSubmit = (e) => {
    e.preventDefault();

    onSubmit(term);
  };

  return (
    <div
      className="search-bar inverted ui segment"
      style={{ width: "1140px", padding: "16px" }}
    >
      <div className="logo-content">
        <img src="youtube.png" alt="logo" className="logo-img"></img>
        <h1
          className="logo-texts"
          style={{ fontFamily: "myFont", fontSize: "36px", lineHeight: "30px" }}
        >
          μTube
        </h1>
      </div>
      <form className="ui form form-content" onSubmit={onFormSubmit}>
        <div className="field">
          <label style={{ color: "white" }}>
            <i className="red video icon"></i>
            Search for a Video:
          </label>
          <div className="ui left icon input" style={{ width: "750px" }}>
            <i className="search icon"></i>
            <input
              id="focus"
              type="text"
              placeholder="(e.g. Mo Salah Screamer vs. Chelsea)"
              value={term}
              onChange={onInputChange}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default SearchBar;
